import { AUTH_PATHS } from "@/constants/paths";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ArrowRight, CheckCircle2 } from "lucide-react";

export default function ForgotPasswordSent() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email")?.trim() ?? "";

  if (!email) {
    return (
      <div
        className={cn(
          "flex flex-col bg-card p-4 rounded-lg shadow w-full max-w-md",
        )}
      >
        <div className="mb-4 space-y-1 text-center">
          <h2 className="text-lg font-semibold text-foreground">
            رابط غير صالح
          </h2>
          <p className="text-sm text-muted-foreground">
            يرجى إدخال بريدك الإلكتروني مرة أخرى لإرسال رابط إعادة التعيين.
          </p>
        </div>

        <Button asChild className="w-full">
          <Link to={AUTH_PATHS.FORGOT_PASSWORD}>طلب رابط جديد</Link>
        </Button>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex flex-col bg-card p-4 rounded-lg shadow w-full max-w-md",
      )}
    >
      <div className="mb-4 space-y-3 text-center">
        <div className="flex justify-center">
          <CheckCircle2 className="h-10 w-10 text-primary" />
        </div>
        <h2 className="text-lg font-semibold text-foreground">
          تحقق من بريدك الإلكتروني
        </h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          تم إرسال رابط إعادة تعيين كلمة المرور إلى{" "}
          <span className="font-medium text-foreground">{email}</span>. يرجى
          التحقق من بريدك الإلكتروني.
        </p>
      </div>

      <Button asChild variant="outline" className="w-full">
        <Link to={AUTH_PATHS.LOGIN}>
          <ArrowRight className="ml-2 h-4 w-4" />
          العودة لتسجيل الدخول
        </Link>
      </Button>
    </div>
  );
}
